import React, { useEffect, useRef } from 'react';
import { ChatMessage } from '../ChatMessage/ChatMessage';
import { Message } from '../../../types/chat.types';
import {
  ChatMessages as ChatMessages__Root,
  ChatMessages__List,
  ChatMessages__ScrollAnchor,
} from './ChatMessages.styles';

export interface ChatMessagesProps {
  messages: Message[];
  onFeedback: (messageId: string, traceId: string, isPositive: boolean, resetSelection: () => void) => void;
}

export const ChatMessages: React.FC<ChatMessagesProps> = ({
  messages,
  onFeedback
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  return (
    <ChatMessages__Root>
      <ChatMessages__List>
        {messages.map(message => (
          <ChatMessage
            key={message.id}
            message={message}
            onFeedback={onFeedback}
          />
        ))}
        <ChatMessages__ScrollAnchor ref={messagesEndRef} />
      </ChatMessages__List>
    </ChatMessages__Root>
  );
};
